import { useState, useEffect, useRef } from 'react';
import { Button} from '@mui/material';
import { jaJP } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import BackspaceIcon from '@mui/icons-material/Backspace';
import DoneIcon from '@mui/icons-material/Done';
import { useAuth } from '../../contexts/AuthContext';
import { usePost } from '../../apis/ApiRequests';
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid';
import CustomSnackBar from '../../components/alert/CustomSnackBar';
import CustomConfirm from '../../components/confirm/CustomConfirm';
import Header from '../../components/Header';
import Frame from '../../components/uiParts/Frame';
import TitleBar from '../../components/uiParts/TitleBar';
import MastaSearchForm from '../../components/uiParts/maintenance/MastaSearchForm';
import CustomOutlinedInput from '../../components/input/CustomOutlinedInput';
import { authorityList } from '../../Store';
import CustomSelect from '../../components/select/CustomSelect';
import { read, utils } from 'xlsx';

const UserList = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - ベース情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth();
    const token          = authInfo.token;
    const facilityCode   = authInfo.facilityCode;
    const facilityName   = authInfo.facilityName;
    const loginUserId    = authInfo.userId;
    const loginUserName  = authInfo.userName;
    const lobinAuthority = authInfo.authority;
    
	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ dataGridHeight,    setDataGridHeight    ] = useState(window.innerHeight - 250);
    const [ condition ,        setCondition         ] = useState('');
    const [ userList,          setUserList          ] = useState([]);
    const [ searchCount,       setSearchCount       ] = useState(0);
    const [ targetList,        setTargetList        ] = useState('');
    const [ traderList,        setTraderList        ] = useState([]);
    const [ senmeiList,        setSenmeiList        ] = useState([]);
    const [ userId,            setUserId            ] = useState('');
    const [ name,              setName              ] = useState('');
    const [ password,          setPassword          ] = useState('');
    const [ authority,         setAuthority         ] = useState('');
    const [ traderCode,        setTraderCode        ] = useState('');
    const [ senmeiCode,        setSenmeiCode        ] = useState('');
    const [ openDialog,        setOpenDialog        ] = useState(false);
    const [ openConfirm,       setOpenConfirm       ] = useState(false);
    const [ openSnackBarTrue,  setOpenSnackBarTrue  ] = useState(false);
    const [ openSnackBarFalse, setOpenSnackBarFalse ] = useState(false);
    const [ openRequire,       setOpenRequire       ] = useState(false);
    const [ requireMessage,    setRequireMessage    ] = useState('');
    const [ openConfirm_excel, setOpenConfirm_excel ] = useState(false);
    const [ excelDataList,     setExcelDataList     ] = useState([]);
    const [ excelImportFlag,   setExcelImportFlag   ] = useState(false);
    const [ fileName,          setFileName          ] = useState('');
    
	//-----------------------------------------------
    // initialize - useRef
	//-----------------------------------------------
    const fileInputRef = useRef();
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - searchData / masta_User
	//-----------------------------------------------
    const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost();
    const searchData = async () => {
        const postData = {
            'className'    : 'mch.models.masta.User',
            'methodName'   : 'searchData',
            'token'        : token,
            'facilityCode' : facilityCode,
            'userId'       : loginUserId,
            'keyword1'     : condition
        }
        await searchData_post(postData);
    };
	//-----------------------------------------------
    // API - マスタリストの取得
	//-----------------------------------------------
    const { response : setData_res, post:setData_post } = usePost();
    const setData = async (registerData) => {
        const postData = {
            'className'    : 'mch.models.masta.User',
            'methodName'   : 'setData',
            'token'        : token,
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'activeFlag'   : registerData.activeFlag,
            'userId'       : registerData.userId,
            'name'         : registerData.name,
            'password'     : registerData.password,
            'authority'    : registerData.authority,
            'traderCode'   : registerData.traderCode,
            'senmeiCode'   : registerData.senmeiCode
        }
        await setData_post(postData);
    };
	//-----------------------------------------------
    // API - 仲買人マスタリストの取得
	//-----------------------------------------------
    const { response : getDataAll_trader_res, post : getDataAll_trader_post } = usePost();
    const getDataAll_trader = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Trader',
            'methodName'   : 'searchData',
            'token'        : token,
            'facilityCode' : facilityCode,
            'userId'       : loginUserId
        }
        await getDataAll_trader_post(postData);
    };
	//-----------------------------------------------
    // API - 荷主マスタリストの取得
	//-----------------------------------------------
    const { response : getDataAll_ship_res, post : getDataAll_ship_post } = usePost();
    const getDataAll_ship = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'searchData',
            'token'        : token,
            'facilityCode' : facilityCode,
            'userId'       : loginUserId
        }
        await getDataAll_ship_post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1);

        getDataAll_trader();
        getDataAll_ship();
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 250);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    },[]);
    //-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_trader)
    //-----------------------------------------------
    useEffect(() => {
        setTraderList([]);
        if (getDataAll_trader_res) {
            setTraderList(getDataAll_trader_res.Data);
        }
    }, [getDataAll_trader_res]);
    //-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_ship)
    //-----------------------------------------------
    useEffect(() => {
        setSenmeiList([]);
        if (getDataAll_ship_res) {
            setSenmeiList(getDataAll_ship_res.Data);
        }
    }, [getDataAll_ship_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / masta_user)
	//-----------------------------------------------
    useEffect(() => {
        setUserList([]);
        if (searchData_res) {
            setUserList(searchData_res.Data);
        }
    }, [searchData_res]);
	//-----------------------------------------------
    // useEffect - APIコール（登録処理）
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            setOpenDialog(false);
            handleCloseConfirm();
            handleClickSnackBarTrue();
            setSearchCount(searchCount+1);
        }
    }, [setData_res]);
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData();
    }, [searchCount])
	//-----------------------------------------------
    // useEffect - dataGirdの選択
	//-----------------------------------------------
    useEffect(() => {
        if (targetList) {
            setUserId(targetList.userId);
            setName(targetList.name);
            setPassword(targetList.password);
            setAuthority(targetList.authority);
            setTraderCode(targetList.traderCode);
            setSenmeiCode(targetList.senmeiCode);
            setOpenDialog(true); // ダイアログを表示
        }
    }, [targetList]);
	//-----------------------------------------------
    // useEffect - エクセルファイル取り込み処理
	//-----------------------------------------------
    useEffect(() => {
        if (excelImportFlag) {            
            excelDataList.map((item) => {
                const registerData = {
                    'activeFlag' : 1,
                    'userId'     : item.userId,
                    'name'       : item.name,
                    'password'   : item.password,
                    'authority'  : item.authority,
                    'traderCode' : item.traderCode,
                    'senmeiCode' : item.senmeiCode
                }
                setData(registerData);
            });
            setExcelImportFlag(false);
            handleCloseConfirm_excel();
        }
    }, [excelDataList, excelImportFlag]);

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
    };
	//-----------------------------------------------
    // eventHandler - 検索ボタン
	//-----------------------------------------------
    const handleClick_search = () => {
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 検索クリアボタン
	//-----------------------------------------------
    const handleClick_search_clear = () => {
        setCondition('');
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 新規ボタン
	//-----------------------------------------------
    const handleClick_new = () => {
        setUserId('');
        setName('');
        setPassword('');
        setAuthority('');
        setTraderCode('');
        setSenmeiCode('');
        setOpenDialog(true);
    };
	//-----------------------------------------------
    // eventHandler - 登録ボタン
	//-----------------------------------------------
    const handleClick_Register = (activeFlag) => {
        const requireStatus = checkedRequire(); // 必須項目をチェックする
        if (requireStatus) {
            const registerData = {
                'activeFlag'   : activeFlag,
                'userId'       : userId,
                'name'         : name,
                'password'     : password,
                'authority'    : authority,
                'traderCode'   : traderCode,
                'senmeiCode'   : senmeiCode
            }
            setData(registerData);
        } else {
            handleClickSnackBarRequire();
        }
    };
	//-----------------------------------------------
    // eventHandler - ダイアログを非表示
	//-----------------------------------------------
    const handleClick_dialog_close = () => {
        setOpenDialog(false);
    };
	//-----------------------------------------------
	// eventHandler - 権限の変更
	//-----------------------------------------------
    const handleChangexAuthority = (value) => {
        if (value == 0) {
            setAuthority('');
        } else {
            setAuthority(value);
        }
    };
	//-----------------------------------------------
	// eventHandler - 仲買人の変更
	//-----------------------------------------------
    const handleChangexTrader= (value) => {
        if (value == 0) {
            setTraderCode('');
        } else {
            setTraderCode(value);
        }
    };
	//-----------------------------------------------
	// eventHandler - 荷主の変更
	//-----------------------------------------------
    const handleChangexSenmei= (value) => {
        if (value == 0) {
            setSenmeiCode('');
        } else {
            setSenmeiCode(value);
        }
    };
	//-----------------------------------------------
    // eventHandler - EXCELファイルの取り込み
	//-----------------------------------------------
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
    
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = read(data, { type: 'array' });
    
                const sheetName = 'ユーザ'; // 読み込むシート名
                const worksheet = workbook.Sheets[sheetName];
    
                if (!worksheet) {
                    setRequireMessage("指定されたシート名が存在しません。");
                    handleClickSnackBarRequire();
                    return;
                }
    
                // シートからデータをJSON形式で取得
                const jsonData = utils.sheet_to_json(worksheet, { header: 1 });
                const rows = jsonData.map((row, index) => {
                    if (index === 0) return null; // ヘッダー行をスキップ
                    return {
                        userId     : row[0] || '',
                        name       : row[1] || '',
                        password   : row[2] || '',
                        authority  : row[3] || '',
                        traderCode : row[4] || '',
                        senmeiCode : row[5] || ''
                    };
                }).filter(row => row !== null);
    
                handleOpenConfirm_excel();
                setExcelDataList(rows);
            };
            reader.readAsArrayBuffer(file);
        }
    };
	//-----------------------------------------------
    // eventHandler - EXCELファイルの参照
	//-----------------------------------------------
    const handeliClick_excel = () => {
        fileInputRef.current.click()
    };
    const handliClick_excelImportOK = () => {
        setExcelImportFlag(true)
    };
    //===============================================
    // dataGird
    //===============================================
    //-----------------------------------------------
    // dataGird - テーブルの見出し
    //-----------------------------------------------
    const columns = [
        { field: 'id',        headerName: 'No',     width: 100, columnSeparatorWidth: 1, type:'number', },
        {
            field: 'activeFlag',
            headerName: '状態',
            width: 90,
            renderCell: (params) => (
                <div
                    style={{
                        color: params.value ? 'inherit' : 'red', 
                    }}
                >
                    {statusMapping[params.value] || params.value}
                </div>
            ),
          },
        { field: 'userId',    headerName: 'ユーザID',  width: 150, columnSeparatorWidth: 1, },
        { field: 'name',      headerName: '名称',    width: 200, columnSeparatorWidth: 1, },
        {
            field: 'authority',
            headerName: '権限',
            width: 150,
            renderCell: (params) => (
                <div>
                    {authorityMapping[params.value] || params.value}
                </div>
            ),
          },
          {
            field: 'traderCode',
            headerName: '仲買人',
            width: 200,
            renderCell: (params) => {
                const trader = traderList.find(t => t.code === params.value);
                return <div>{trader ? trader.name : '不明'}</div>;
            },
          },
          {
            field: 'senmeiCode',
            headerName: '荷主',
            width: 200,
            renderCell: (params) => {
                const senmei = senmeiList.find(t => t.code === params.value);
                return <div>{senmei ? senmei.name : '不明'}</div>;
            },
          },
    ]
    const statusMapping = {
        0: '利用不可',
        1: '利用可',
    }
    const authorityMapping = {
        1: 'システム管理者',
        2: '漁協ユーザ',
        3: '一般ユーザ',
        4: '漁業者ユーザ'
    };  
    //-----------------------------------------------
    // dataGrid - 行の選択
    //-----------------------------------------------
    const handleClick_dataGrid = (event) => {
        setTargetList(event.row);
    };
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = [];
    
        if (!userId) errorFields.push('「コード」');
        if (!name) errorFields.push('「名称」');
        if (!password) errorFields.push('「表示名称」');
    
        if (errorFields.length) {
            const text = errorFields.join('、') + 'が入力されていません';
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        } 
        return true;  // エラーがない場合は true を返します
    };
	//===============================================
	// UI Message
	//===============================================
    // コンファームの表示
    const handleOpenConfirm = () => { setOpenConfirm(true) };
    
    // コンファームを閉じる
    const handleCloseConfirm = () => { setOpenConfirm(false) };

    // コンファームの表示
    const handleOpenConfirm_excel = () => { setOpenConfirm_excel(true) };
    
    // コンファームを閉じる
    const handleCloseConfirm_excel = () => { setOpenConfirm_excel(false) };
    
    // スナックバー(必須チェック)を表示
    const handleClickSnackBarRequire = () => { setOpenRequire(true) };
    
	// スナックバー(必須チェック)を閉じる
    const handleCloseSnackBarRequire = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenRequire(false);
    };
	// スナックバー(正常)を表示
    const handleClickSnackBarTrue = () => { setOpenSnackBarTrue(true) };
    
	// スナックバー(正常)を閉じる
    const handleCloseSnackBarTrue = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarTrue(false);
    };
	// スナックバー(異常)を表示
    const handleClickSnackBarFalse = () => { setOpenSnackBarFalse(true) };
    
	// スナックバー(異常)を閉じる
    const handleCloseSnackBarFalse = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarFalse(false);
    };
    //===============================================
    // Css
    //===============================================
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'320px', color:'#fff', backgroundColor:'#808080'
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/systemMastaMenu" setEntryDate={handleChange_entryDate} />
            <div className='userList bodyContens'>
                <TitleBar title="ユーザマスタ一覧" />
                <div className='mainContents'>
                    <Frame classname="frame" title="マスタ検索">
                        <MastaSearchForm
                            id                = "userList_condition"
                            value             = { condition }
                            handleChange      = { (e) => setCondition(e.target.value) }
                            handleSearch      = { () => handleClick_search() }
                            handleSearchClear = { () => handleClick_search_clear() }
                            handleClickNew    = { () => handleClick_new() }
                            excelRef            = { fileInputRef }
                            handleExcelOnchange = { (e) => handleFileChange(e) }
                            handleExcelClick    = { (e) => handeliClick_excel(e) }
                        />
                    </Frame>
                    <Frame classname="frame" title="マスタ一覧">
                        <CustomDataGrid
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                            }
                            editMode                = "row"
                            rows                    = { userList }
                            columns                 = { columns }
                            sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                            density                 = "compact"
                            localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                            showColumnRightBorder
                            showCellRightBorder
                            initialState            = {{pagination: { paginationModel: { pageSize: 100 } },}}
                            pageSizeOptions         = {[50, 100, 150, 200]}
                            loading                 = { searchData_Loading }
                            onCellClick             = {(event) => handleClick_dataGrid(event)}
                        />
                    </Frame>
                </div>
            </div>
            <div className='userList_dialog'>
                <Dialog open={ openDialog } onClose={ handleClick_dialog_close } maxWidth='lg' >
                    <DialogTitle>
                        <TitleBar title="ユーザマスタ登録" />
                    </DialogTitle>
                    <DialogContent style={{border:'none'}} sx = {{width:'auto'}}>
                        <div style={{backgroundColor:'#efefef', padding:'10px'}}>
                            <div>
                                <CustomOutlinedInput
                                    id       = "userList_code"
                                    label    = "ユーザID"
                                    value    = { userId }
                                    width    = "300px"
                                    onChange = {(e) => setUserId(e.target.value)}
                                />
                            </div>
                            <div style={{marginTop:'10px'}}>
                                <CustomOutlinedInput
                                    id       = "userList_name"
                                    label    = "名称"
                                    value    = { name }
                                    width    = "300px"
                                    onChange = {(e) => setName(e.target.value)}
                                />
                            </div>
                            <div style={{marginTop:'10px'}}>
                                <CustomOutlinedInput
                                    id       = "userList_password"
                                    label    = "パスワード"
                                    value    = { password }
                                    width    = "300px"
                                    onChange = {(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <div style={{marginTop:'10px'}}>
                                <CustomSelect
                                    id         = "userList_authority"
                                    label      = "権限"
                                    width      = "300px"
                                    dataList   = {authorityList} 
                                    selectedId = {authority} 
                                    onChange   = {(e) => handleChangexAuthority(e.target.value)} 
                                />
                            </div>
                            <div style={{marginTop:'10px'}}>
                                <CustomSelect
                                    id         = "userList_traderCode"
                                    label      = "所属仲買人"
                                    width      = "300px"
                                    dataList   = {traderList} 
                                    selectedId = {traderCode} 
                                    onChange   = {(e) => handleChangexTrader(e.target.value)} 
                                />
                            </div>
                            <div style={{marginTop:'10px'}}>
                                <CustomSelect
                                    id         = "userList_senmeiCode"
                                    label      = "所属荷主"
                                    width      = "300px"
                                    dataList   = {senmeiList} 
                                    selectedId = {senmeiCode} 
                                    onChange   = {(e) => handleChangexSenmei(e.target.value)} 
                                />
                            </div>
                            <div style={{display:'flex', marginRight:'10px',marginTop:'15px'}}>
                                <div style={{marginLeft:'5px'}}>
                                    <Button
                                        color     = "attention"
                                        size      = "large"
                                        variant   = "contained"
                                        sx        = {{width:'140px', color:'#fff'}}
                                        onClick   = { () => handleOpenConfirm() }
                                        startIcon = {<BackspaceIcon />}
                                    >{'削除'}
                                    </Button>
                                    
                                </div>
                                <div>
                                    <Button
                                        color     = "primary"
                                        size      = "large"
                                        variant   = "contained"
                                        sx        = {{width:'140px', marginLeft:'10px'}}
                                        onClick   = { () => handleClick_Register(1) }
                                        startIcon = {<DoneIcon />}
                                    >{'登録'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div style={{marginTop:'20px'}}>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                onClick   = {() => handleClick_dialog_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
                <CustomSnackBar
                    open            = {openSnackBarTrue}
                    onClose         = {() => handleCloseSnackBarTrue()}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {openSnackBarFalse}
                    onClose         = {() => handleCloseSnackBarFalse()}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {openRequire}
                    onClose         = {() => handleCloseSnackBarRequire()}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {openConfirm}
                    onClose   = {() => handleCloseConfirm()}
                    onClickNG = {() => handleCloseConfirm()}
                    onClickOK = {() => handleClick_Register(0)}
                    message   = "指定データの削除を行います。よろしいですか？"
                />
                <CustomConfirm
                    open      = {openConfirm_excel}
                    onClose   = {() => handleCloseConfirm_excel()}
                    onClickNG = {() => handleCloseConfirm_excel()}
                    onClickOK = {() => handliClick_excelImportOK()}
                    message   = "エクセルファイルのアップロードを行います。よろしいですか？"
                />
            </div>
        </>
    )
}
export default UserList;